document.addEventListener('DOMContentLoaded', () => {
  const productJson = [...document.querySelectorAll('[id^=ProductJson-')];
  if (productJson.length > 0) {
    productJson.forEach((product) => {
      const sectionId = product.id.replace("ProductJson-", "shopify-section-");
      const VariantTitle = document.querySelector('#' + sectionId + ' .variant-title');
      const BreadCrumb = document.querySelector('#' + sectionId + ' .breadcrumb-item.active');
      const variantSKU = document.querySelector('#' + sectionId + ' .variant-sku');
      const variantPrice = document.querySelector('#' + sectionId + ' .variant-price');
      const variantATC = document.querySelector('#' + sectionId + ' .variant-atc');
      const inputSelects = [...document.querySelectorAll('#' + sectionId + ' .single-option-selector')];
      const productInfo = JSON.parse(product.innerHTML);
      const inputValues = [];
      const optionValues = [];
      let count = 0;
      let defVariant = inputSelects[0].dataset.defVariant;
      if (defVariant) {
        document.querySelectorAll('.gallery-thumbs-image').forEach((thumb) => {
          // visually hide gallery image too let pdImage = document.querySelector(`.swiper-slide[data-gallery-variants="${thumb.dataset.variants}"]`) 
          if (thumb.dataset.variants.includes(defVariant)) {
            thumb.classList.remove("d-none")
            // visually hide gallery image too pdImage.classList.remove("swiper-slide-invisible-blank") 
          } else if (thumb.dataset.variants != "" ) {
            thumb.classList.add("d-none")
            // visually hide gallery image too pdImage.classList.add("swiper-slide-invisible-blank") 
          }
        });
      }

      inputSelects.forEach((input) => {
        inputValues.push(input.value);
        optionValues.push(count);
        input.addEventListener('change', (evt) => {
          const currentValue = evt.currentTarget.value.toString();
          const changedIndex = inputSelects.indexOf(evt.target);
          inputValues[changedIndex] = currentValue;
          variantSKU.innerText = ' ';
          productInfo.variants.forEach((variant) => {
            if (variant.id == currentValue) {
              VariantTitle.innerText = variant.title;
              BreadCrumb.innerText = variant.title;

              variantSKU.innerText = variant.sku;
              variantPrice.innerText = Shopify.formatMoney(variant.price, theme.moneyFormat);
              var idx = 0;
              var changeImg = false;

              if (variant.available) {
                variantATC.classList.remove("disabled");
                variantATC.innerHTML = "Add to cart";
              } else {
                variantATC.innerHTML = "Out of stock";
                variantATC.classList.add("disabled");
              }

              document.querySelectorAll('.gallery-thumbs-image').forEach((thumb) => {
                // visually hide gallery image too let pdImage = document.querySelector(`.swiper-slide[data-gallery-variants="${thumb.dataset.variants}"]`) 
                if (thumb.dataset.variants.includes(variant.id)) {
                  thumb.classList.remove("d-none")
                  // visually hide gallery image too pdImage.classList.remove("swiper-slide-invisible-blank") 
                  changeImg = true;
                } else if (thumb.dataset.variants != "" ) {
                  thumb.classList.add("d-none")
                  // visually hide gallery image too pdImage.classList.add("swiper-slide-invisible-blank") 
                }
                if (!changeImg) {
                  idx += 1;
                }
              });
              if (changeImg) {
                imgGallery.slideTo(idx);
              }
            }
          });
        });
        count += 1;
      });
    });
  }
});
